import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Outlet, NavLink } from 'react-router-dom';
import useMatchMedia from 'hooks/useMatchMedia';
import CheckcircleIcon from 'icons/Checkcircle.icon';
import { LEAD_STAGES } from 'models/Lead';
import DealContext from '../../providers/Deal/Deal.context';
import InterestToggle from './components/InterestToggle';
import GuideCard from 'components/GuideCard';
import SparklesIcon from 'icons/Sparkles.icon';
import GuideTour from 'providers/GuideTour/GuideTour.provider';
import { CONFIGURE_SELECTOR, GUIDE_STEPS } from './data';
import WorkflowHeader from './components/WorkflowHeader';
import WorkflowPopupNotification from '../../providers/WorkflowPopupNotification/WorkflowPopupNotification.provider';

import './WorkflowConfiguration.styles.scss';
import './WorkflowConfiguration.styles.responsive.scss';

const WorkflowConfiguration: React.FC = () => {
  const { leadStagesCopies } = useContext(DealContext);

  const isAbovePhablet = useMatchMedia('isAbovePhablet');

  const { t } = useTranslation();

  const classes = classNames('workflow-configuration', 'white-panel');

  return (
    <GuideTour guideSteps={GUIDE_STEPS}>
      <WorkflowPopupNotification>
        <div className={classes}>
          <WorkflowHeader />

          <div className="workflow-configuration__content">
            <aside>
              <nav>
                <p className="wft-title">
                  {t('leadStages')}
                  <GuideCard
                    onHover
                    hasCloseButton={false}
                    anchor={
                      <span className="guide-anchor" id={CONFIGURE_SELECTOR}>
                        <SparklesIcon />
                      </span>
                    }
                    title="configureLeadStages"
                    description="configureLeadStagesDescription"
                  />
                </p>

                <ul className="workflow-configuration__menu">
                  {Object.values(LEAD_STAGES).map((step, index) => (
                    <li key={step}>
                      <NavLink
                        className={({ isActive }) =>
                          classNames({ active: isActive })
                        }
                        to={step}
                        replace={isAbovePhablet}
                      >
                        <div className="workflow-configuration__link-info">
                          <p>{`${t('stage')} ${index + 1}`}</p>
                          <p>{t(leadStagesCopies[step])}</p>
                        </div>
                        <CheckcircleIcon />
                      </NavLink>

                      <InterestToggle step={step} />
                    </li>
                  ))}
                </ul>
              </nav>
            </aside>

            <main>
              <Outlet />
            </main>
          </div>
        </div>
      </WorkflowPopupNotification>
    </GuideTour>
  );
};

export default WorkflowConfiguration;
